

var $window = $(window);

// キービジュアルと箱
var $visual = $('.js-visual');
var $box = $('.js-visual-box');

var window_h = null; // ウィンドウサイズ
var visual_h = null; // キービジュアルの高さ
var box_h = null; // キービジュアルを格納する枠の高さ
var box_w = null;
var footer_h = null;

var transform = require('../caracol2/effect/transform_css.js');

page_home();

function page_home(){
	'use strict';
	// #page-home 以外は抜ける
	if( !$('#page-home').length ) return;

	if( !$.isMobile ){
	    setTimeout( function(){
			// ビジュアルのリサイズ
			$window.on( 'resize', $.throttle( 100, resize_visual ));
			resize_visual();
			// スクロールでビジュアルを動かす
			$window.on( 'scroll', scroll_visual );
			scroll_visual();
	    }, 200);
	}

	// Twitterウィジェット幅調整
	if( $('body').hasClass('isMobile') ){
	    setTimeout( function(){
	        $('.home-twitter iframe').width(
	            $('.home-twitter .home-widget__body').width()
	        );
	    }, 500)
	}

	// wordprss記事一覧
	require('../module/wordpress.js');

	// パーティクル
	require('../module/particle.js');

	// フェードイン後の処理を登録する
	$(window).on('onFadeinComplete', after_fadein);
}

/**
 * フェードイン後の処理
 */
function after_fadein() {
	// PV再生
	var $movie = $('.js-youtube');
	if ($movie.data('open-movie') == true && Cookies.get('is_movie_showed') != 'true') {
		$movie.trigger('click');
		Cookies.set('is_movie_showed', 'true', { epires: 1 });
	}
}


/*************************
* ビジュアルのスクロール
*/
function scroll_visual(){
	// 必要なスクロール量
	var box_scroll_max = box_h - window_h;
	var visual_scroll_max = visual_h - window_h;

	// キービジュアルとのスクロール比率
	var scroll_par = visual_scroll_max / box_scroll_max;
	// 現在のスクロール量
	var now_scroll = $window.scrollTop();
	// ビジュアルのスクロールする量
	var visual_scroll = now_scroll * scroll_par;
	visual_scroll = Math.min( visual_scroll, visual_scroll_max );

// console.log(window_h,  box_h,  visual_h,  box_scroll_max,  visual_scroll_max);

	var style = $visual.get(0).style;
	transform.set_transform( style, 'translateY(-'+visual_scroll+'px)' );
}

/*************************
* ビジュアルのリサイズ
*/
function resize_visual(){
	var VISUAL_W = 1059;
	var VISUAL_H = 1411;
	// // var VISUAL_H_MAX = 1287

	// // 一度高さを 0 にしてから枠のサイズを計測
	// $visual.hide();
	box_w = $box.width();
	// box_h = $box.height();

	// // 縦横どっちの比率を使うか
	// var par = Math.max( box_w / VISUAL_W, box_h / VISUAL_H );
	var par = box_w * 1.05 / VISUAL_W;

	$visual.css({width:VISUAL_W*par, height:VISUAL_H*par});
	// $visual.show();


	// // リサイズ後を取得
	visual_h = $visual.height();
	box_h = $box.height();
	window_h = $window.height();
	footer_h = $('.l-footer').height();
}



